// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"443":"about","894":"services"}[chunkId] + "." + {"443":"439c5f97","894":"1b4aea9b"}[chunkId] + ".js";
};